export const getReminders = (state) => state.reminders.reminders;
export const getReminderPending = (state) => state.reminders.pending;
export const getRemindersItem = (state) => state.reminders.remindersItem;
export const getReminderElem = (state) => state.reminders.reminder;
